import { Type } from "class-transformer";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumber, IsOptional, IsString, MaxLength } from "class-validator";
import { QualityTypeEnum } from "@gtpl/shared-models/common-models";

export class QaqcFibreLabAnalysisDto {
    @ApiPropertyOptional()
    id: number;

    @ApiProperty()
    @IsString()
    
    @IsOptional()
    @MaxLength(100, { message: "Work Order No Length Should be less than or Equal to 100" })
    workOrderNo: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(255, { message: "Lot Number Length Should be less than or Equal to 255" })
    lotNumber: string;

    @ApiProperty()
    @IsString()
    
    @MaxLength(100, { message: "Operation Length Should be less than or Equal to 100" })
    operation: string;

    @ApiProperty()
    @IsString()
    
    @MaxLength(100, { message: "Previous Operation Length Should be less than or Equal to 100" })
    prevOperation: string;

    @ApiProperty()
  
    
    @IsOptional()
    product: Number;

    @ApiProperty()
    @IsOptional()
    
    @MaxLength(100, { message: "Quality Length Should be less than or Equal to 100" })
    quality: QualityTypeEnum;
    

    @ApiPropertyOptional()
    @IsNumber()
    oilTest: number;

    @ApiPropertyOptional()
    @IsNumber()
    sericinTest: number;

    @ApiPropertyOptional()
    @IsNumber()
    acidityTest: number;

    @ApiPropertyOptional()
    @IsNumber()
    ppContent: number;

    @ApiPropertyOptional()
    @IsNumber()
    moistureContent: number;

    @ApiProperty()
    quantity: any;

    @ApiProperty()
    testDate: any;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    testType: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    analysisType: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    @MaxLength(500, { message: "Remarks Length Should be less than or Equal to 500" })
    remarks: string;

    @ApiPropertyOptional()
    @IsString()
    @IsOptional()
    createdUser?: string;

    @ApiPropertyOptional()
    @IsString()
     @IsOptional()
    updatedUser?: string;

    @ApiPropertyOptional()
        @IsString()
        @IsOptional()
        oilTestRemarks: string;

        @ApiPropertyOptional()
        @IsString()
        @IsOptional()
        sericinTestRemarks: string;

        @ApiPropertyOptional()
        @IsString()
        @IsOptional()
        acidityTestRemarks: string; 

        @ApiPropertyOptional()
        @IsString() 
        @IsOptional()   
        moistureContentRemarks: string;

        @ApiPropertyOptional()
        @IsString()
        @IsOptional()
        ppContentRemarks: string;

        @IsOptional()
        productionInventoryId?: number;
    }

export class CreateQaqcFibreLabAnalysisDto extends QaqcFibreLabAnalysisDto {}

export class UpdateQaqcFibreLabAnalysisDto extends QaqcFibreLabAnalysisDto {
    @ApiProperty()
    @IsNotEmpty()
    id: number;
}
